/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SampleContainerTestSample from './sample-container-test-sample';
import SampleContainerTestSampleDetail from './sample-container-test-sample-detail';
import SampleContainerTestSampleUpdate from './sample-container-test-sample-update';
import SampleContainerTestSampleDeleteDialog from './sample-container-test-sample-delete-dialog';

const SampleContainerTestSampleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SampleContainerTestSample />} />
    <Route path="new" element={<SampleContainerTestSampleUpdate />} />
    <Route path=":id">
      <Route index element={<SampleContainerTestSampleDetail />} />
      <Route path="edit" element={<SampleContainerTestSampleUpdate />} />
      <Route path="delete" element={<SampleContainerTestSampleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SampleContainerTestSampleRoutes;
